import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {forkJoin} from "rxjs";
import {HttpStatusCode} from "@angular/common/http";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums/index";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';


@Component({
  selector: 'app-sales-credit-summary-general',
  templateUrl: './sales-credit-summary-general.component.html',
  styles: [
  ]
})
export class SalesCreditSummaryGeneralComponent implements  OnInit{
  requestId: string;
  data = signal<any>({});
  categoryCode: string;
  flowCode: string;
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Resumen del crédito'];
  request: any
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private salesWorkflowService: SalesWorkflowService,
              public macroFlowService: MacroFlowService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.utilService.enablePageLoading();
    this.data.set(this.request);
    this.utilService.disablePageLoading();
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onGotoStep(stepCode: string) {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode:this.flowCode, stepCode, categoryId: this.requestService.categoryId });
  }

  getCanCancelRequest(): boolean {
    return this.salesWorkflowService.canCancelRequest();
  }

  frequencyText(): string {
    return this.utilService.getFrequencyDescription(this.data().quotes?.frecuency);
  }

  hasAdditionalProduct(): boolean {
    return !!this.data()?.additional_product;
  }

  getAdditionalProduct(): any {
    return this.data()?.additional_product;
  }

  getAdditionalProductNetAmount(): number {
    const additionalProduct = this.getAdditionalProduct();
    if (!additionalProduct) {
      return 0;
    }

    if (additionalProduct.net_amount !== undefined && additionalProduct.net_amount !== null) {
      return Number(additionalProduct.net_amount) || 0;
    }

    const amount = Number(additionalProduct.amount) || 0;
    const discountPct = Number(additionalProduct.discount_pct) || 0;
    return amount * (1 - discountPct / 100);
  }

  getProductsSubtotal(): number {
    return Number(this.data()?.quotes?.prices?.selected) || 0;
  }

  getMainProductAmount(): number {
    const selectedPrice = this.getProductsSubtotal();
    if (!this.hasAdditionalProduct()) {
      return selectedPrice;
    }

    return selectedPrice - this.getAdditionalProductNetAmount();
  }

  getInstallmentAmount(): number {
    return Number(this.data()?.quotes?.installment?.selected) || 0;
  }

  getFinancedTotalAmount(): number {
    return this.getProductsSubtotal() - this.getInstallmentAmount();
  }


  get hideChangeProductButton(): boolean {
    return this.salesWorkflowService.currentStep?.setting?.hide_change_product_button?.value === true;
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly SalesWorkflow = SalesWorkflow;

}
